import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export default function AuditLogs() {
  const [data, setData] = useState({ items: [], total: 0, modules: [], actions: [] });
  const [page, setPage] = useState(1);
  const [module, setModule] = useState("");
  const [action, setAction] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.get("/audit-logs", { params: { page, page_size: 50, module: module || undefined, action: action || undefined, search: search || undefined } })
      .then(({ data }) => setData(data)).catch((e) => toast.error(errMsg(e)));
  }, [page, module, action, search]);

  return (
    <div className="space-y-4" data-testid="audit-page">
      <h1 className="font-serif text-3xl font-semibold text-[#0f2545] sm:text-4xl">Audit Logs</h1>
      <div className="flex flex-wrap gap-2">
        <select data-testid="audit-module" value={module} onChange={(e) => { setModule(e.target.value); setPage(1); }} className="rounded-md border border-slate-300 px-2 py-2 text-sm">
          <option value="">All Modules</option>{data.modules.map((m) => <option key={m}>{m}</option>)}
        </select>
        <select data-testid="audit-action" value={action} onChange={(e) => { setAction(e.target.value); setPage(1); }} className="rounded-md border border-slate-300 px-2 py-2 text-sm">
          <option value="">All Actions</option>{data.actions.map((a) => <option key={a}>{a}</option>)}
        </select>
        <input data-testid="audit-search" value={search} onChange={(e) => { setSearch(e.target.value); setPage(1); }} placeholder="Search user or beneficiary ID" className="min-w-[220px] flex-1 rounded-md border border-slate-300 px-3 py-2 text-sm" />
      </div>
      <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
        <table className="min-w-[1000px] w-full text-sm">
          <thead className="bg-slate-100 text-left text-xs uppercase text-slate-600"><tr>{["Date / Time", "User", "Role", "Module", "Action", "Beneficiary", "Previous", "New", "Reason", "IP"].map((h) => <th key={h} className="p-3">{h}</th>)}</tr></thead>
          <tbody data-testid="audit-rows">
            {data.items.map((l) => (
              <tr key={`${l.created_at}-${l.user}-${l.action}-${l.beneficiary_id ?? ""}`} className="border-t border-slate-100">
                <td className="whitespace-nowrap p-3 text-xs">{new Date(l.created_at).toLocaleString("en-IN")}</td>
                <td className="p-3 font-medium">{l.user}</td><td className="p-3 text-xs">{l.role}</td>
                <td className="p-3">{l.module}</td><td className="p-3">{l.action}</td>
                <td className="p-3 font-mono text-xs">{l.beneficiary_id || "—"}</td>
                <td className="p-3 text-xs">{String(l.old_value ?? "—")}</td><td className="p-3 text-xs">{String(l.new_value ?? "—")}</td>
                <td className="p-3 text-xs">{l.reason || "—"}</td><td className="p-3 text-xs">{l.ip || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex items-center justify-between border-t border-slate-200 p-3 text-sm">
          <span>Showing {data.items.length} of {data.total}</span>
          <div className="flex gap-2">
            <button disabled={page === 1} onClick={() => setPage(page - 1)} className="rounded-md border border-slate-300 px-3 py-1.5 disabled:opacity-40">Prev</button>
            <button disabled={page * 50 >= data.total} onClick={() => setPage(page + 1)} className="rounded-md border border-slate-300 px-3 py-1.5 disabled:opacity-40">Next</button>
          </div>
        </div>
      </div>
    </div>
  );
}
